import React from 'react'
import { Box, Button, ButtonProps, CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

interface Props extends ButtonProps {
    loading?: boolean
    loadingIndicator?: React.ReactNode
    loadingPosition?: 'start' | 'end' | 'center'
}

const RelativeContainer = styled('div')`
    position: relative;
`

const AbsoluteCenteredContainer = styled('div')`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -8px;
    margin-left: -8px;
`

/** Based on [@mui/lab/LoadingButton](https://mui.com/material-ui/react-button/#loading-button) */
export const SparkLoadingButton: React.VFC<Props> = ({
    children,
    disabled,
    loading,
    loadingPosition,
    startIcon,
    endIcon,
    loadingIndicator = <CircularProgress size={16} sx={{ color: 'text.disabled' }} />,
    ...rest
}: Props) => {
    const buttonStartIcon =
        loading && (loadingPosition === 'start' || !loadingPosition) && !!startIcon ? loadingIndicator : startIcon
    const buttonEndIcon =
        loading && (loadingPosition === 'end' || !loadingPosition) && !!endIcon ? loadingIndicator : endIcon
    const onlyShowLoadingIndicatorOnIcon = !!startIcon || !!endIcon

    return (
        <Box>
            <Button
                startIcon={buttonStartIcon}
                endIcon={buttonEndIcon}
                variant="contained"
                disabled={loading || disabled}
                {...rest}
            >
                <RelativeContainer>
                    {onlyShowLoadingIndicatorOnIcon ? (
                        <Box>{children}</Box>
                    ) : (
                        <>
                            <Box visibility={loading ? 'hidden' : 'visible'}>{children}</Box>
                            <AbsoluteCenteredContainer sx={{ visibility: loading ? 'visible' : 'hidden' }}>
                                {loadingIndicator}
                            </AbsoluteCenteredContainer>
                        </>
                    )}
                </RelativeContainer>
            </Button>
        </Box>
    )
}
